import {
  TipoCompetenciaCobrancaEnum,
  TipoVencimentoCobrancaEnum,
} from "features/condominio/typings";

export function mapTipoVencimentoToLabel(
  tipoVencimento: TipoVencimentoCobrancaEnum
): string {
  const map = {
    [TipoVencimentoCobrancaEnum.GerarTodasCobrançasVencimento]:
      "Gerar todas as cobranças no vencimento",
    [TipoVencimentoCobrancaEnum.GerarTodasCobrançasDiaUtil]:
      "Gerar todas as cobranças em dia útil",
    [TipoVencimentoCobrancaEnum.GerarApenasArrecadaçoesDiaUtil]:
      "Gerar apenas arrecadações em dia útil",
  };

  return map[tipoVencimento];
}

export function getOptionsTipoVencimento() {
  return [
    {
      label: mapTipoVencimentoToLabel(
        TipoVencimentoCobrancaEnum.GerarTodasCobrançasVencimento
      ),
      value: TipoVencimentoCobrancaEnum.GerarTodasCobrançasVencimento,
    },
    {
      label: mapTipoVencimentoToLabel(
        TipoVencimentoCobrancaEnum.GerarTodasCobrançasDiaUtil
      ),
      value: TipoVencimentoCobrancaEnum.GerarTodasCobrançasDiaUtil,
    },
    {
      label: mapTipoVencimentoToLabel(
        TipoVencimentoCobrancaEnum.GerarApenasArrecadaçoesDiaUtil
      ),
      value: TipoVencimentoCobrancaEnum.GerarApenasArrecadaçoesDiaUtil,
    },
  ];
}

export function mapCompetenciaArrecadacaoToLabel(
  competencia: TipoCompetenciaCobrancaEnum
): string {
  const map = {
    [TipoCompetenciaCobrancaEnum.DoisMesesAntesVencimento]:
      "Dois meses antes do vencimento",
    [TipoCompetenciaCobrancaEnum.MesAnteriorAoVencimento]:
      "Mês anterior ao vencimento",
    [TipoCompetenciaCobrancaEnum.MesDoVencimento]: "Mês do vencimento",
  };

  return map[competencia];
}

export function getOptionsCompetencia() {
  return [
    {
      label: mapCompetenciaArrecadacaoToLabel(
        TipoCompetenciaCobrancaEnum.DoisMesesAntesVencimento
      ),
      value: TipoCompetenciaCobrancaEnum.DoisMesesAntesVencimento,
    },
    {
      label: mapCompetenciaArrecadacaoToLabel(
        TipoCompetenciaCobrancaEnum.MesAnteriorAoVencimento
      ),
      value: TipoCompetenciaCobrancaEnum.MesAnteriorAoVencimento,
    },
    {
      label: mapCompetenciaArrecadacaoToLabel(
        TipoCompetenciaCobrancaEnum.MesDoVencimento
      ),
      value: TipoCompetenciaCobrancaEnum.MesDoVencimento,
    },
  ];
}
